"use client";

import type React from "react";
import { useState, useEffect } from "react";
import {
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  HStack,
  Box,
} from "@chakra-ui/react";
import type { PostCallAnalysisData } from "./PostCallAnalysis";

interface BooleanAnalysisFormProps {
  onSave: (data: PostCallAnalysisData) => void;
  onCancel: () => void;
  initialData?: PostCallAnalysisData;
}

export const BooleanAnalysisForm: React.FC<BooleanAnalysisFormProps> = ({
  onSave,
  onCancel,
  initialData,
}) => {
  const [name, setName] = useState(initialData?.name || "");
  const [description, setDescription] = useState(
    initialData?.description || ""
  );

  useEffect(() => {
    if (initialData) {
      setName(initialData.name);
      setDescription(initialData.description);
    }
  }, [initialData]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      type: "boolean",
      name,
      description,
    });
  };

  return (
    <Box mb={4}>
      <form onSubmit={handleSubmit}>
        <VStack spacing={4} align="stretch">
          <FormControl isRequired>
            <FormLabel fontSize="sm" color="secondary.700">
              Name
            </FormLabel>
            <Input
              id="boolean-analysis-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="appointment_booked"
              size="sm"
              focusBorderColor="primary.500"
              _placeholder={{ color: "gray.500" }}
              variant="outline"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel fontSize="sm" color="secondary.700">
              Description
            </FormLabel>
            <Input
              id="boolean-analysis-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Did the user book an appointment?"
              size="sm"
              focusBorderColor="primary.500"
              _placeholder={{ color: "gray.500" }}
              variant="outline"
            />
          </FormControl>

          <HStack justify="flex-end" spacing={2}>
            <Button variant="ghost" size="sm" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              type="submit"
              size="sm"
              bg="primary.500"
              color="white"
              _hover={{ bg: "primary.600" }}
            >
              {initialData ? "Update" : "Save"}
            </Button>
          </HStack>
        </VStack>
      </form>
    </Box>
  );
};
